import Services from './base-services'

const service = new Services('mdDiagnostico')

export default {
    findDiagnosticoPendiente(userId:any, isFinished: boolean = false) {
        return service.get(`findDiagnosticoPendiente?userId=${userId}&isFinished=${isFinished}`)
    },
    answerDiagnostico(data: any) {
        return service.post(`answerDiagnostico`, data)
    },
}
